import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Category} from "../../models/category";
import {CategoryService} from "../../services/category.service";

@Injectable()
export class ServiceCategoriesResolve implements Resolve<Category[]> {
    constructor(private categoryService: CategoryService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Category[]> {
        return this.categoryService.getAllByType('service');
    }
}
